<div class="container-fluid">
  <div class="row">
    <div class="col-md-12">
      <nav
        class="breadcrumb-container d-flex align-items-center justify-content-between mb-3 mt-md-0 mt-4"
      >
        <div class="d-flex align-items-center flex-wrap gap-2">
          <!-- Back Button -->
          <a
            class="back-link d-flex align-items-center justify-content-center me-3"
            routerLink="/api/{{ appId }}"
            [title]="'COMMON.BACK' | translate"
          >
            <mat-icon>arrow_back</mat-icon>
          </a>

          <!-- Application Info -->
          <div class="d-flex align-items-center me-2">
            <div
              class="avatar-wrapper position-relative border rounded flex-shrink-0"
              style="width: 36px; height: 36px; overflow: visible"
            >
              <div
                style="width: 100%; height: 100%; overflow: hidden"
                class="rounded"
              >
                <img
                  [src]="getDocThumbnail(applogo)"
                  class="w-100 h-100"
                  style="object-fit: contain"
                  alt="{{ appName }}"
                />
              </div>
            </div>
            <div class="ms-3">
              <h6 class="mb-0 text-dark lh-1 text-wrap text-break">
                {{ appName }}
              </h6>
            </div>
          </div>
          <!-- Separator -->
          <i class="bx bx-chevron-right text-muted mx-2 opacity-50"></i>
          <!-- Usecase Section -->
          <div class="d-flex align-items-center">
            <h6 class="mb-0 text-dark text-wrap text-break">
              {{ usecase?.name || ("COMMON.USECASE" | translate) }}
            </h6>
          </div>
          <!-- Separator -->
          <i class="bx bx-chevron-right text-muted mx-2 opacity-50"></i>
          <!-- Form Section -->
          <div class="d-flex align-items-center">
            <div class="me-2 d-flex align-items-center justify-content-center">
              <mat-icon color="primary">credit_card</mat-icon>
            </div>
            <h6 class="mb-0 text-dark text-wrap text-break">
              {{ "COMMON.FORM" | translate }}
            </h6>
          </div>
        </div>
      </nav>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-md-12 col-xl-4 px-2 mb-2">
      <div class="card shadow-sm h-100">
        <div class="card-header">
          <div class="d-flex align-items-center justify-content-between">
            <h6 class="m-0">
              {{ "COMMON.LIST" | translate }}
            </h6>
            <div>
              <ul class="nav nav-pills" id="pills-tab" role="tablist">
                <li
                  class="nav-item compact-inputs"
                  role="presentation"
                  *ngIf="!isArchivedlistTabActive"
                >
                  <button
                    mat-stroked-button
                    color="primary"
                    class="small-button border-primary"
                    id="pills-mainlist-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-mainlist"
                    type="button"
                    role="tab"
                    (click)="toggleTab('archivedlist'); searchArchived()"
                    [matTooltip]="'APPLICATIONS.ARCHIVE' | translate"
                    matTooltipPosition="above"
                  >
                    <mat-icon class="icon-compact">unarchive</mat-icon>
                    <small>{{ "APPLICATIONS.ARCHIVE" | translate }}</small>
                  </button>
                </li>

                <li
                  class="nav-item"
                  role="presentation"
                  *ngIf="isArchivedlistTabActive"
                >
                  <button
                    mat-stroked-button
                    color="primary"
                    id="pills-archivedlist-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-archivedlist"
                    type="button"
                    role="tab"
                    (click)="toggleTab('mainlist')"
                    class="small-button"
                    [matTooltip]="'COMMON.MAIN_LIST' | translate"
                    matTooltipPosition="above"
                  >
                    <mat-icon class="icon-compact">list</mat-icon>
                    <small>{{ "COMMON.MAIN_LIST" | translate }}</small>
                  </button>
                </li>

                <li class="nav-item ms-1" role="presentation">
                  <button
                    mat-stroked-button
                    color="primary"
                    id="pills-trash-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-trash"
                    type="button"
                    role="tab"
                    (click)="toggleTab('trashlist'); searchTrash()"
                    class="small-button"
                    [matTooltip]="'COMMON.TRASH' | translate"
                  >
                    <mat-icon class="icon-compact">delete_outline</mat-icon>
                    <small>{{ "COMMON.TRASH" | translate }}</small>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div class="card-body half-screen p-1 compact-inputs">
          <div class="tab-content" id="pills-tabContent">
            <!-- Main List Tab -->
            <div
              class="tab-pane fade"
              [class.show]="!isArchivedlistTabActive && !isTrashTabActive"
              [class.active]="!isArchivedlistTabActive && !isTrashTabActive"
              id="pills-home"
              role="tabpanel"
              aria-labelledby="pills-home-tab"
            >
              <div class="d-flex flex-column mt-2 mytext-primary darkmode-div">
                <div
                  *ngFor="let e of form['list']; let i = index"
                  class="card border-0 shadow-sm border-start border-4 transition-all mb-2"
                  [ngClass]="
                    selectedEditItemId === e['id']
                      ? 'border-primary bg-light'
                      : 'border-light bg-white'
                  "
                >
                  <div
                    class="p-2 d-flex align-items-center justify-content-between flex-wrap gap-2"
                  >
                    <!-- Left side: Number and Title -->
                    <div
                      class="d-flex align-items-center flex-grow-1 overflow-hidden mb-2"
                    >
                      <span
                        class="badge rounded-pill bg-secondary bg-opacity-10 text-dark me-2 px-2 py-1"
                        style="font-size: 0.75rem"
                      >
                        {{ i + 1 }}
                      </span>
                      <a
                        href="javascript:void(0)"
                        class="text-decoration-none fw-bold text-dark text-truncate d-block"
                        [title]="e['title']"
                      >
                        {{ e["title"] | truncate: 25 }}
                      </a>
                    </div>

                    <!-- Right side: Action Buttons -->
                    <div class="d-flex align-items-center gap-1">
                      <div class="d-flex gap-2 flex-wrap">
                        <!-- Edit Button -->
                        <button
                          mat-button
                          class="btn btn-sm sm-btn"
                          [ngClass]="
                            selectedEditItemId === e['id']
                              ? 'bg-primary bg-opacity-10 primary-text border border-primary border-opacity-25 border-start-4'
                              : 'bg-light primary-text'
                          "
                          (click)="
                            get(e['id']);
                            getFormId(e);
                            selectedEditItemId = e['id']
                          "
                          [matTooltip]="'COMMON.EDIT' | translate"
                        >
                          <div
                            class="d-flex align-items-center justify-content-center"
                          >
                            <i class="bx bx-edit"></i>
                            <small class="ms-1">{{
                              "COMMON.EDIT" | translate
                            }}</small>
                          </div>
                        </button>

                        <!-- Dashboard Toggle Button -->
                        <button
                          mat-button
                          class="btn btn-sm sm-btn bg-light primary-text"
                          (click)="
                            addDashboard(e['id']); selectedEditItemId = null
                          "
                          [matTooltip]="
                            e['showDashboard'] === 1
                              ? ('DASHBOARD.REMOVE' | translate)
                              : ('DASHBOARD.ADD' | translate)
                          "
                        >
                          <div
                            class="d-flex align-items-center justify-content-center"
                          >
                            <i
                              *ngIf="
                                !e['showDashboard'] ||
                                e['showDashboard'] === null ||
                                e['showDashboard'] === 0
                              "
                              class="bx bx-customize"
                            ></i>
                            <i
                              *ngIf="e['showDashboard'] === 1"
                              class="bx bx-window-close"
                            ></i>
                            <small class="ms-1">
                              {{
                                e["showDashboard"] === 1
                                  ? ("DASHBOARD.REMOVE" | translate)
                                  : ("DASHBOARD.ADD" | translate)
                              }}
                            </small>
                          </div>
                        </button>

                        <!-- View Button -->
                        <button
                          mat-button
                          class="btn btn-sm sm-btn bg-light primary-text"
                          (click)="gotoForm(e.id)"
                          [matTooltip]="'COMMON.VIEW' | translate"
                        >
                          <div
                            class="d-flex align-items-center justify-content-center"
                          >
                            <i class="bx bx-show-alt"></i>
                            <small class="ms-1">{{
                              "COMMON.VIEW" | translate
                            }}</small>
                          </div>
                        </button>

                        <!-- Archive Button -->
                        <button
                          mat-button
                          class="btn btn-sm sm-btn bg-light primary-text"
                          (click)="setSelectedItem(e.id)"
                          [matTooltip]="'APPLICATIONS.ARCHIVE' | translate"
                        >
                          <div
                            class="d-flex align-items-center justify-content-center"
                          >
                            <i class="bx bx-archive-in"></i>
                            <small class="ms-1">{{
                              "APPLICATIONS.ARCHIVE" | translate
                            }}</small>
                          </div>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Archived List Tab -->
            <div
              class="tab-pane fade"
              [class.show]="isArchivedlistTabActive && !isTrashTabActive"
              [class.active]="isArchivedlistTabActive && !isTrashTabActive"
              id="pills-profile"
              role="tabpanel"
              aria-labelledby="pills-profile-tab"
            >
              <div
                class="d-flex flex-column card border-0 shadow-sm border-light bg-white"
              >
                <div
                  *ngFor="let e of form.archivedlist; let i = index"
                  class=""
                >
                  <div
                    class="card-body p-2 px-2 d-flex align-items-center justify-content-between flex-wrap gap-2"
                  >
                    <div class="d-flex align-items-center">
                      <span
                        class="badge rounded-pill bg-secondary bg-opacity-10 text-dark me-2 px-2 py-1"
                        style="font-size: 0.75rem"
                      >
                        {{ i + 1 }}
                      </span>
                      <span
                        class="fw-bold text-dark text-truncate d-block cursor-pointer"
                        [title]="e['title']"
                      >
                        {{ e["title"] | truncate }}
                      </span>
                    </div>
                    <div class="d-flex gap-1">
                      <button
                        mat-stroked-button
                        color="primary"
                        [matTooltip]="'APPLICATIONS.RETRIEVE' | translate"
                        (click)="retrieve(e.id)"
                        class="icon-center icon-width"
                      >
                        <mat-icon class="icon-compact">unarchive</mat-icon>
                      </button>
                      <button
                        mat-stroked-button
                        color="warn"
                        [matTooltip]="'COMMON.DELETE' | translate"
                        (click)="setSelectedItem(e['id'])"
                        class="icon-center icon-width"
                      >
                        <mat-icon class="icon-compact">delete</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Trash Tab -->
            <div
              class="tab-pane fade"
              [class.show]="isTrashTabActive"
              [class.active]="isTrashTabActive"
              id="pills-trash"
              role="tabpanel"
              aria-labelledby="pills-trash-tab"
            >
              <div
                class="d-flex flex-column card border-0 shadow-sm border-light bg-white"
              >
                <div
                  *ngFor="let e of form['trashlist']; let i = index"
                  class=""
                >
                  <div
                    class="card-body p-2 px-2 d-flex align-items-center justify-content-between flex-wrap gap-2"
                  >
                    <div class="d-flex align-items-center">
                      <span
                        class="badge rounded-pill bg-secondary bg-opacity-10 text-dark me-2 px-2 py-1"
                        style="font-size: 0.75rem"
                      >
                        {{ i + 1 }}
                      </span>
                      <span
                        class="fw-bold text-dark text-truncate d-block cursor-pointer"
                        [title]="e['title']"
                        (click)="get(e['id'])"
                      >
                        {{ e["title"] | truncate }}
                      </span>
                    </div>
                    <div class="d-flex gap-1">
                      <button
                        mat-stroked-button
                        color="primary"
                        [matTooltip]="'APPLICATIONS.RETRIEVE' | translate"
                        (click)="retrieve(e.id)"
                        class="icon-center icon-width"
                      >
                        <mat-icon class="icon-compact">unarchive</mat-icon>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 col-xl-8 px-2 mb-2">
      <div class="card shadow-sm h-100">
        <div class="card-header">
          <!-- Error/Success Message -->
          <p *ngIf="form['error'] == false && form['message']">
            <app-ncs-alert [message]="form['message']" type="success" />
          </p>
          <p *ngIf="form['error'] == true && form['message']">
            <app-ncs-alert [message]="form['message']" type="danger" />
          </p>

          <div
            class="d-flex justify-content-between align-items-center flex-wrap gap-3"
          >
            <h6
              class="m-0 text-wrap text-break me-2"
              *ngIf="form.data['id'] > 0"
            >
              {{ form.data["title"] }}
            </h6>
            <h6
              class="m-0 text-wrap text-break me-2"
              *ngIf="form.data['id'] == 0 || form.data['id'] == null"
            >
              {{ "COMMON.ADD" | translate }}
            </h6>
            <div
              class="d-flex flex-wrap align-items-center flex-wrap gap-2 btn-toggle-group"
            >
              <div *ngIf="form.data['title']" class="d-flex align-items-center">
                <mat-button-toggle-group
                  name="columns"
                  [value]="form.data['columns'] || 1"
                  (change)="form.data['columns'] = $event.value"
                  color="primary"
                >
                  <mat-button-toggle
                    [value]="1"
                    [matTooltip]="'FORM.SET_COLUMNS' | translate: { value: 1 }"
                    class="small-toggle"
                  >
                    <mat-icon class="number-icon">filter_1</mat-icon>
                  </mat-button-toggle>
                  <mat-button-toggle
                    [value]="2"
                    [matTooltip]="'FORM.SET_COLUMNS' | translate: { value: 2 }"
                    class="small-toggle"
                  >
                    <mat-icon class="number-icon">filter_2</mat-icon>
                  </mat-button-toggle>
                  <mat-button-toggle
                    [value]="3"
                    [matTooltip]="'FORM.SET_COLUMNS' | translate: { value: 3 }"
                    class="small-toggle"
                  >
                    <mat-icon class="number-icon">filter_3</mat-icon>
                  </mat-button-toggle>
                  <mat-button-toggle
                    [value]="4"
                    [matTooltip]="'FORM.SET_COLUMNS' | translate: { value: 4 }"
                    class="small-toggle"
                  >
                    <mat-icon class="number-icon">filter_4</mat-icon>
                  </mat-button-toggle>
                </mat-button-toggle-group>
              </div>

              <button
                mat-stroked-button
                color="primary"
                [disabled]="!uiForm.valid"
                (click)="save()"
                type="button"
                class="small-button"
              >
                <mat-icon class="button-icon">save</mat-icon>
                {{ "COMMON.SAVE" | translate }}
              </button>

              <button
                mat-stroked-button
                color="primary"
                [matTooltip]="'COMMON.NEW' | translate"
                (click)="resetForm()"
                class="small-button"
              >
                <mat-icon class="button-icon">add</mat-icon>
                {{ "COMMON.NEW" | translate }}
              </button>
            </div>
          </div>
        </div>

        <div class="card-body half-screen compact-inputs dropdown-pd-none">
          <form #uiForm="ngForm">
            <!-- Title Input -->
            <div class="row mb-3">
              <label for="title" class="col-md-2 col-form-label text-start">
                {{ "FORM.FIELDS.TITLE" | translate }}
              </label>
              <div class="col-md-10">
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    required
                    (input)="checkUsecaseName($event)"
                    [(ngModel)]="form.data['title']"
                    type="text"
                    id="title"
                    name="title"
                    maxlength="50"
                    placeholder="{{ 'FORM.FIELDS.TITLE' | translate }}"
                  />
                </mat-form-field>
                <span class="text-danger">{{ form.inputerror["title"] }}</span>
              </div>
            </div>

            <!-- Subtitle Input -->
            <div class="row mb-3">
              <label for="subtitle" class="col-md-2 col-form-label text-start">
                {{ "FORM.FIELDS.SUBTITLE" | translate }}
              </label>
              <div class="col-md-10">
                <mat-form-field appearance="outline" class="w-100">
                  <input
                    matInput
                    [(ngModel)]="form.data['subtitle']"
                    type="text"
                    id="subtitle"
                    name="subtitle"
                    [placeholder]="'FORM.FIELDS.SUBTITLE' | translate"
                  />
                  <span class="text-danger">{{
                    form.inputerror["subtitle"]
                  }}</span>
                </mat-form-field>

                <!-- Hidden columns field (if you still need it) -->
                <input
                  hidden
                  [(ngModel)]="form.data['columns']"
                  type="text"
                  name="columns"
                />
              </div>
            </div>

            <!-- Description Textarea -->
            <div class="row mb-3">
              <label
                for="description"
                class="col-md-2 col-form-label text-start"
              >
                {{ "COMMON.DESCRIPTION" | translate }}
              </label>
              <div class="col-md-10 textarea-container">
                <mat-form-field appearance="outline" class="w-100">
                  <textarea
                    matInput
                    [(ngModel)]="form.data['description']"
                    id="description"
                    name="description"
                    rows="3"
                    [placeholder]="'COMMON.DESCRIPTION' | translate"
                  >
                  </textarea>
                </mat-form-field>
              </div>
            </div>

            <!-- Read Only Select -->
            <div class="row mb-3">
              <label for="readOnly" class="col-md-2 col-form-label text-start">
                {{ "FORM.FIELDS.READ_ONLY" | translate }}
              </label>
              <div class="col-md-10">
                <mat-form-field appearance="outline" class="w-100">
                  <mat-select
                    [(ngModel)]="form.data['readOnly']"
                    id="readOnly"
                    name="readOnly"
                  >
                    <mat-option [value]="undefined" disabled>
                      {{ "COMMON.SELECT" | translate }}
                    </mat-option>
                    <mat-option [value]="false">{{
                      "COMMON.FALSE" | translate
                    }}</mat-option>
                    <mat-option [value]="true">{{
                      "COMMON.TRUE" | translate
                    }}</mat-option>
                  </mat-select>
                  <span class="text-danger">{{
                    form.inputerror["readOnly"]
                  }}</span>
                </mat-form-field>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>

  <div class="row compact-inputs dropdown-pd-none">
    <div class="col-12">
      <div class="card" *ngIf="form.data['id'] > 0">
        <div>
          <div class="card-header">
            <div class="d-flex flex-wrap align-items-center gap-2">
              <h5 class="mb-0">
                {{ "FORM.DESIGN.TITLE" | translate }}
              </h5>
            </div>
          </div>
        </div>
        <div class="card-body">
          <!-- Raman starts here -->
          <div
            class="row align-items-end g-2 flex-wrap mb-3"
            *ngIf="form.data['id'] > 0"
          >
            <!-- ================= INPUT FIELDS ================= -->
            <div class="col-auto">
              <mat-form-field appearance="outline" style="width: 180px">
                <mat-label>
                  {{ "FORM.DESIGN.INPUT_FIELDS_PLACEHOLDER" | translate }}
                </mat-label>

                <mat-select
                  #inputField
                  name="usecaseAttribute"
                  (openedChange)="listOfAttributes()"
                >
                  <mat-option [value]="null" disabled>
                    {{ "FORM.DESIGN.INPUT_FIELDS_PLACEHOLDER" | translate }}
                  </mat-option>

                  <mat-option
                    *ngFor="let c of showUsecaseAttributes"
                    [value]="c.id"
                    [title]="c.label"
                  >
                    {{ c.label | truncate: 20 }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-auto">
              <button
                mat-stroked-button
                color="primary"
                (click)="addField(inputField.value); inputField.value = null"
              >
                <mat-icon>add</mat-icon>
                {{ "COMMON.ADD" | translate }}
              </button>
            </div>

            <!-- ================= INPUT BUTTONS ================= -->
            <div class="col-auto">
              <mat-form-field appearance="outline" style="width: 180px">
                <mat-label>
                  {{ "FORM.DESIGN.INPUT_BUTTONS_PLACEHOLDER" | translate }}
                </mat-label>

                <mat-select
                  #buttonSelect
                  [(ngModel)]="selectedButton"
                  (openedChange)="selectButton()"
                >
                  <mat-option [value]="null" disabled>
                    {{ "FORM.DESIGN.INPUT_BUTTONS_PLACEHOLDER" | translate }}
                  </mat-option>

                  <mat-option
                    *ngFor="let button of buttonList"
                    [value]="button.value"
                  >
                    {{ button.icon }} {{ button.label | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-auto">
              <!-- <button mat-stroked-button color="primary" [disabled]="!selectedButton"
                                (click)="addSelectedButtons(); buttonSelect.value = null">
                                <mat-icon>add</mat-icon>
                                {{ 'COMMON.ADD' | translate }}
                            </button> -->
              <button
                mat-stroked-button
                color="primary"
                [disabled]="!selectedButton"
                (click)="
                  selectedButton === 'custom'
                    ? openCustomButtonModal()
                    : addSelectedButtons();
                  buttonSelect.value = null
                "
              >
                <mat-icon>add</mat-icon>
                {{ "COMMON.ADD" | translate }}
              </button>
            </div>

            <!-- ================= CUSTOM BUTTON ================= -->
            <!-- <div class="col-auto" *ngIf="selectedButton === 'custom'">
                            <mat-form-field appearance="outline" style="width: 180px;">
                                <mat-label>
                                    {{ 'FORM.DESIGN.BUTTON_LABEL_PLACEHOLDER' | translate }}
                                </mat-label>
                                <input matInput [(ngModel)]="buttonLabel">
                            </mat-form-field>
                        </div>

                        <div class="col-auto" *ngIf="selectedButton === 'custom'">
                            <mat-form-field appearance="outline" style="width: 180px;">
                                <mat-label>
                                    {{ 'FORM.DESIGN.ACTION_URL_PLACEHOLDER' | translate }}
                                </mat-label>
                                <input matInput [(ngModel)]="actionUrl">
                            </mat-form-field>
                        </div> -->

            <!-- ================= CHILD USECASE ================= -->
            <div class="col-auto">
              <mat-form-field appearance="outline" style="width: 180px">
                <mat-label>
                  {{ "FORM.DESIGN.CHILD_FIELD_PLACEHOLDER" | translate }}
                </mat-label>

                <mat-select
                  #childUsecase
                  [(ngModel)]="selectedChildUsecase"
                  (selectionChange)="selectedChild(selectedChildUsecase)"
                >
                  <mat-option [value]="null" disabled>
                    {{ "FORM.DESIGN.CHILD_FIELD_PLACEHOLDER" | translate }}
                  </mat-option>

                  <mat-option *ngFor="let c of selectChildList" [value]="c.id">
                    {{ c.name | truncate: 20 }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <!-- ================= CHILD FORM ================= -->
            <div class="col-auto">
              <mat-form-field appearance="outline" style="width: 180px">
                <mat-label>
                  {{ "FORM.DESIGN.CHILD_FORM_FIELD_PLACEHOLDER" | translate }}
                </mat-label>

                <mat-select #childForm [(ngModel)]="selectedChildForm">
                  <mat-option [value]="null" disabled>
                    {{ "FORM.DESIGN.CHILD_FORM_FIELD_PLACEHOLDER" | translate }}
                  </mat-option>

                  <mat-option *ngFor="let c of selectChildFormList" [value]="c">
                    {{ c.title | truncate: 20 }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <div class="col-auto">
              <button
                mat-stroked-button
                color="primary"
                (click)="
                  addChildFields();
                  childUsecase.value = null;
                  childForm.value = null
                "
              >
                <mat-icon>add</mat-icon>
                {{ "COMMON.ADD" | translate }}
              </button>
            </div>

            <!-- ================= PREVIEW ================= -->
            <div class="col-auto">
              <button
                mat-stroked-button
                color="primary"
                data-bs-toggle="modal"
                data-bs-target="#previewModal"
              >
                <mat-icon>view_column</mat-icon>
                {{ "FORM.DESIGN.PREVIEW" | translate }}
              </button>
            </div>

            <!-- ================= SECTION ================= -->
            <div class="col-auto">
              <button
                mat-stroked-button
                color="primary"
                data-bs-toggle="modal"
                data-bs-target="#groupModal"
              >
                <mat-icon>add</mat-icon>
                {{ "FORM.DESIGN.SECTION" | translate }}
              </button>
            </div>
          </div>
          <!-- Raman end here -->

          <div class="row">
            <div class="col-12 mb-3">
              <div class="table-container">
                <div
                  class="table-responsive table-scrollable"
                  *ngIf="form.data['id'] > 0"
                >
                  <table
                    class="table table-bordered table-hover table-sticky-header"
                  >
                    <thead>
                      <tr>
                        <th>
                          {{ "FORM.FIELDS.LIST_VIEW" | translate }}
                          <i
                            class="bi bi-question-circle fs-6 ms-2 text-secondary cursor"
                            ncsTooltip
                            matTooltipPosition="above"
                            [matTooltip]="'FORM.TOOLTIPS.LIST_VIEW' | translate"
                          ></i>
                        </th>

                        <th>
                          {{ "FORM.FIELDS.LABEL" | translate }}
                          <i
                            class="bi bi-question-circle fs-6 ms-2 text-secondary cursor float-end"
                            ncsTooltip
                            matTooltipPosition="above"
                            [matTooltip]="'FORM.TOOLTIPS.LABEL' | translate"
                          ></i>
                        </th>

                        <th hidden>
                          {{ "FORM.FIELDS.MOVE" | translate }}
                          <i
                            class="bi bi-question-circle fs-6 ms-2 text-secondary cursor float-end"
                            ncsTooltip
                            matTooltipPosition="above"
                            [matTooltip]="'FORM.TOOLTIPS.MOVE' | translate"
                          ></i>
                        </th>

                        <th>
                          {{ "FORM.FIELDS.COLUMN" | translate }}
                          <i
                            class="bi bi-question-circle fs-6 ms-2 text-secondary cursor"
                            ncsTooltip
                            matTooltipPosition="above"
                            [matTooltip]="'FORM.TOOLTIPS.COLUMN' | translate"
                          ></i>
                        </th>

                        <th>
                          {{ "FORM.FIELDS.ROW" | translate }}
                          <i
                            class="bi bi-question-circle fs-6 ms-2 text-secondary cursor"
                            ncsTooltip
                            matTooltipPosition="above"
                            [matTooltip]="'FORM.TOOLTIPS.ROW' | translate"
                          ></i>
                        </th>

                        <th>
                          {{ "FORM.FIELDS.SHOW_WHEN" | translate }}
                          <i
                            class="bi bi-question-circle fs-6 ms-2 text-secondary cursor float-end"
                            ncsTooltip
                            matTooltipPosition="above"
                            [matTooltip]="'FORM.TOOLTIPS.SHOW_WHEN' | translate"
                          ></i>
                        </th>

                        <th>
                          {{ "FORM.FIELDS.EVENT" | translate }}
                          <i
                            class="bi bi-question-circle fs-6 ms-2 text-secondary cursor float-end"
                            ncsTooltip
                            matTooltipPosition="above"
                            [matTooltip]="'FORM.TOOLTIPS.EVENT' | translate"
                          ></i>
                        </th>

                        <th>
                          {{ "FORM.FIELDS.RULES" | translate }}
                          <i
                            class="bi bi-question-circle fs-6 ms-2 text-secondary cursor float-end"
                            ncsTooltip
                            matTooltipPosition="above"
                            [matTooltip]="'FORM.TOOLTIPS.RULES' | translate"
                          ></i>
                        </th>

                        <th>
                          {{ "FORM.FIELDS.SECTION" | translate }}
                          <i
                            class="bi bi-question-circle fs-6 ms-2 text-secondary cursor float-end"
                            ncsTooltip
                            matTooltipPosition="above"
                            [matTooltip]="'FORM.TOOLTIPS.SECTION' | translate"
                          ></i>
                        </th>

                        <th>
                          {{ "COMMON.ACTIONS" | translate }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let e of form.data['fields']; let i = index">
                        <td
                          (dragstart)="onDragStart($event, e, i)"
                          (dragover)="onDragOver($event, e, i)"
                          (drop)="onDrop($event, e, i)"
                          (dragend)="onDragEnd($event, e)"
                          draggable="true"
                          class="grabbable text-center"
                        >
                          <div
                            class="d-flex align-items-center justify-content-center gap-2"
                          >
                            <mat-icon
                              class="text-secondary cursor-move"
                              [matTooltip]="'FORM.ACTIONS.MOVE' | translate"
                            >
                              drag_indicator
                            </mat-icon>

                            <mat-checkbox
                              [checked]="ischecked(e.listView)"
                              (change)="checkbox($event, i)"
                              [matTooltip]="
                                'FORM.ACTIONS.VIEW_LIST' | translate
                              "
                              color="primary"
                            >
                            </mat-checkbox>
                          </div>
                        </td>
                        <td class="d-flex nowrap">
                          <div class="d-flex align-items-center gap-1">
                            <mat-form-field
                              appearance="outline"
                              subsriptSizing="dynamic"
                              class="flex-grow-1"
                            >
                              <input
                                matInput
                                id="label-{{ i }}"
                                [(ngModel)]="e.label"
                                [placeholder]="'FORM.FIELDS.LABEL' | translate"
                                (change)="addFeild(i, e.label, 'label')"
                              />
                            </mat-form-field>

                            <button
                              *ngIf="e.refKey === 1"
                              mat-stroked-button
                              color="primary"
                              type="button"
                              (click)="parentFilters(i, e)"
                              class="small-button icon-center icon-width"
                              [matTooltip]="
                                'FORM.ACTIONS.ADD_PARENT_FILTER' | translate
                              "
                              data-bs-toggle="modal"
                              data-bs-target="#parentModal"
                            >
                              <mat-icon class="icon-compact">add</mat-icon>
                            </button>
                          </div>
                        </td>
                        <td>
                          <mat-form-field
                            appearance="outline"
                            subscriptSizing="dynamic"
                            style="width: 70px"
                          >
                            <input
                              matInput
                              id="col-span-{{ i }}"
                              type="number"
                              [value]="getDefaultValue(e.colsize)"
                              [placeholder]="'FORM.FIELDS.COL_SIZE' | translate"
                              min="1"
                              max="4"
                              (input)="onColSizeChange(i, $event)"
                            />
                          </mat-form-field>
                        </td>
                        <td>
                          <mat-form-field
                            appearance="outline"
                            subscriptSizing="dynamic"
                            style="width: 130px"
                          >
                            <input
                              matInput
                              id="row-span-{{ i }}"
                              type="number"
                              [placeholder]="'FORM.FIELDS.ROW_SIZE' | translate"
                              min="1"
                              max="5"
                              [disabled]="!isShowRowSpan(e.id)"
                              (input)="onRowSizeChange(i, $event)"
                            />
                          </mat-form-field>
                        </td>
                        <td>
                          <div class="d-flex align-items-center gap-1">
                            <mat-form-field
                              appearance="outline"
                              subscriptSizing="dynamic"
                            >
                              <input
                                matInput
                                id="show-{{ i }}"
                                [(ngModel)]="e.show"
                                [placeholder]="
                                  'FORM.FIELDS.SHOW_CONDITION' | translate
                                "
                                readonly
                                disabled
                              />
                            </mat-form-field>
                            <button
                              mat-stroked-button
                              color="primary"
                              type="button"
                              (click)="setShowValueValues(i, e)"
                              class="small-button icon-center icon-width"
                              [matTooltip]="'FORM.ACTIONS.ADD_SHOW' | translate"
                              data-bs-toggle="modal"
                              data-bs-target="#showModal"
                            >
                              <mat-icon class="icon-compact">add</mat-icon>
                            </button>
                          </div>
                        </td>

                        <td>
                          <mat-form-field
                            appearance="outline"
                            subscriptSizing="dynamic"
                            class="flex-grow-1"
                          >
                            <mat-label>{{
                              "COMMON.SELECT" | translate
                            }}</mat-label>
                            <mat-select
                              [(ngModel)]="e.event"
                              (selectionChange)="addEvent(i, e)"
                              name="event-{{ i }}"
                            >
                              <mat-option [value]="undefined">
                                {{ "COMMON.SELECT" | translate }}
                              </mat-option>

                              <mat-option value="onChange">
                                {{ "FORM.EVENTS.ON_CHANGE" | translate }}
                              </mat-option>

                              <mat-option value="onClick">
                                {{ "FORM.EVENTS.ON_CLICK" | translate }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>

                        <td>
                          <mat-form-field
                            appearance="outline"
                            subscriptSizing="dynamic"
                            class="flex-grow-1"
                          >
                            <mat-label>{{
                              "COMMON.SELECT" | translate
                            }}</mat-label>
                            <mat-select
                              [(ngModel)]="e.rule"
                              (selectionChange)="addEventRule(i, e)"
                              name="rule-{{ i }}"
                            >
                              <mat-option [value]="undefined">
                                {{ "COMMON.SELECT" | translate }}
                              </mat-option>
                              <mat-option
                                *ngFor="let c of ruleList1"
                                [value]="c.id"
                              >
                                {{ c.name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>

                        <td class="text-center">
                          <mat-form-field
                            appearance="outline"
                            subscriptSizing="dynamic"
                            class="me-2 flex-grow-1"
                          >
                            <mat-label>{{
                              "FORM.FIELDS.SELECT_SECTION" | translate
                            }}</mat-label>
                            <mat-select
                              #field1
                              [(ngModel)]="e.group"
                              (selectionChange)="addGroupAtt($event, i)"
                              name="group-{{ i }}"
                            >
                              <mat-option [value]="undefined">
                                {{ "FORM.FIELDS.SELECT_SECTION" | translate }}
                              </mat-option>
                              <mat-option
                                *ngFor="let group of form.data['groupLabels']"
                                [value]="group.label"
                              >
                                {{ group.label }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </td>

                        <td class="text-center">
                          <button
                            mat-stroked-button
                            color="warn"
                            type="button"
                            (click)="removeField(e.id)"
                            class="icon-center icon-width"
                            [matTooltip]="'COMMON.DELETE' | translate"
                          >
                            <mat-icon class="icon-compact">delete</mat-icon>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div *ngIf="form.data['id'] == 0">
                  {{ "FORM.MESSAGES.SELECT_FORM" | translate }}
                </div>
              </div>
            </div>
            <div class="col-12 my-3">
              <div *ngIf="form.data['id'] > 0">
                <h6 class="border-bottom mb-4">
                  {{ "FORM.BUTTONS.TITLE" | translate }}
                </h6>

                <div class="d-flex flex-wrap align-items-center gap-3">
                  <div
                    *ngFor="let btn of form.data.buttons; let i = index"
                    class="d-flex align-items-center"
                  >
                    <!-- Draggable Button - NO DELETE ICON INSIDE -->
                    <button
                      mat-stroked-button
                      [color]="getButtonColor(btn.name)"
                      class="grabbable"
                      draggable="true"
                      (dragstart)="onDragButtonStart($event, btn, i)"
                      (dragover)="onDragButtonOver($event, i)"
                      (drop)="onDragButtonDrop($event, i)"
                      (dragend)="onDragButtonEnd($event)"
                    >
                      <mat-icon class="icon-compact">{{
                        getMaterialButtonIcon(btn.name)
                      }}</mat-icon>
                      <span>
                        {{ getButtonLabel(btn.name) | translate }}
                      </span>
                    </button>
                    <!-- DELETE ICON - COMPLETELY SEPARATE from draggable button -->
                    <button
                      mat-icon-button
                      type="button"
                      (click)="removeButton(btn.name)"
                      matTooltip="{{ 'COMMON.DELETE' | translate }}"
                      matTooltipPosition="above"
                      class="icon-pd-none"
                    >
                      <mat-icon class="icon-compact text-secondary"
                        >cancel</mat-icon
                      >
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row compact-ui mt-3">
            <div class="col-12">
              <h6 class="border-bottom">
                {{ "ALLREMAININGS.Form_Section" | translate }}
              </h6>
              <div class="">
                <ng-container *ngIf="form.data['id'] > 0; else selectForm">
                  <div class="accordion" id="accordionFlushExample">
                    <div
                      class="accordion-item border-0 mb-3 rounded shadow-sm grabbable"
                      *ngFor="
                        let e of form.data['childFormList'];
                        let i = index
                      "
                      draggable="true"
                      (dragstart)="onDragchildStart($event, e, i)"
                      (dragover)="onDragchildOver($event, e, i)"
                      (drop)="onchildDrop($event, e, i)"
                      (dragend)="onDragchildEnd($event, e)"
                    >
                      <!-- HEADER -->
                      <h2 class="accordion-header">
                        <div
                          class="d-flex align-items-center justify-content-between px-3 py-2"
                        >
                          <!-- Left -->
                          <div class="d-flex align-items-center gap-2">
                            <mat-icon
                              class="text-secondary cursor-move"
                              matTooltip="{{
                                'ALLREMAININGS.Move' | translate
                              }}"
                            >
                              drag_indicator
                            </mat-icon>
                            <span class="fw-semibold me-2">{{ e.title }}</span>
                            <span
                              class="badge bg-secondary-subtle text-secondary"
                            >
                              {{ e.fields?.length || 0 }} fields
                            </span>
                          </div>
                          <!-- Right -->
                          <div class="d-flex align-items-center gap-2">
                            <button
                              mat-stroked-button
                              type="button"
                              class="icon-center icon-width"
                              (click)="isExpanded[i] = !isExpanded[i]"
                              data-bs-toggle="collapse"
                              [attr.data-bs-target]="'#flush-collapse' + i"
                            >
                              <mat-icon
                                class="icon-compact"
                                [style.transform]="
                                  isExpanded[i]
                                    ? 'rotate(180deg)'
                                    : 'rotate(0deg)'
                                "
                                style="transition: transform 0.3s ease"
                              >
                                expand_more
                              </mat-icon>
                            </button>
                            <button
                              mat-stroked-button
                              type="button"
                              color="warn"
                              (click)="deleteChildFields(i)"
                              class="icon-center icon-width"
                              [matTooltip]="'COMMON.DELETE' | translate"
                            >
                              <mat-icon class="icon-compact">delete</mat-icon>
                            </button>
                          </div>
                        </div>
                      </h2>

                      <!--Accordion BODY -->
                      <div
                        [id]="'flush-collapse' + i"
                        class="accordion-collapse collapse"
                      >
                        <div class="accordion-body bg-light rounded-bottom">
                          <ng-container
                            *ngIf="e.fields?.length > 0; else noFields"
                          >
                            <div
                              *ngFor="let field of e.fields; let j = index"
                              class="card mb-2 border-0 shadow-sm"
                            >
                              <div
                                class="card-body py-2 px-3 d-flex align-items-center gap-2"
                              >
                                <span class="badge bg-secondary">
                                  {{ j + 1 }}
                                </span>
                                <mat-form-field
                                  appearance="outline"
                                  subscriptSizing="dynamic"
                                  class="w-100"
                                >
                                  <input
                                    matInput
                                    id="label-{{ i }}-{{ j }}"
                                    [(ngModel)]="field.label"
                                    type="text"
                                    [placeholder]="
                                      'FORM.FIELDS.LABEL' | translate
                                    "
                                    readonly
                                  />
                                </mat-form-field>
                              </div>
                            </div>
                          </ng-container>
                          <!-- EMPTY -->
                          <ng-template #noFields>
                            <div class="text-center text-muted small py-3">
                              <i class="bi bi-folder-x me-1"></i>
                              {{ "FORM.MESSAGES.NO_FIELDS" | translate }}
                            </div>
                          </ng-template>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
                <!-- SELECT FORM -->
                <ng-template #selectForm>
                  <div class="text-center text-muted py-5">
                    <i class="bi bi-ui-checks-grid fs-3 d-block mb-2"></i>
                    {{ "FORM.MESSAGES.SELECT_FORM" | translate }}
                  </div>
                </ng-template>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card" *ngIf="form.data['id'] > 0">
        <div *ngIf="form.data['id'] > 0">
          <div
            class="card-header d-flex align-items-center gap-3 justify-content-between"
          >
            <h5 class="mb-0">{{ "RULES.FORM_EVENTS" | translate }}</h5>
            <button
              mat-stroked-button
              color="primary"
              data-bs-toggle="modal"
              data-bs-target="#addRule"
              (click)="resetRuleDataForm()"
              matTooltip="{{ 'RULES.ADD_RULE' | translate }}"
              matTooltipPosition="above"
              class="d-flex align-items-center"
            >
              <mat-icon class="me-1">add</mat-icon>
              {{ "RULES.ADD_RULE" | translate }}
            </button>
          </div>
          <div class="card-body">
            <div class="table-container dropdown-pd-none">
              <div class="table-responsive table-scrollable">
                <table
                  class="table table-bordered table-hover table-sticky-header"
                >
                  <thead>
                    <tr>
                      <th class="text-center" style="width: 5%">
                        {{ "COMMON.SNO" | translate }}
                      </th>
                      <th>{{ "RULES.SELECT_EVENT" | translate }}</th>
                      <th>{{ "RULES.RULE_LOGIC" | translate }}</th>
                      <th class="text-start">
                        {{ "COMMON.ACTIONS" | translate }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let key of ruleList; let i = index">
                      <td class="text-center" style="width: 5%">{{ i + 1 }}</td>
                      <td>{{ getEventTranslation(key.event) | translate }}</td>
                      <td class="textarea-container">
                        <mat-form-field appearance="outline" class="w-100">
                          <textarea
                            matInput
                            rows="2"
                            [value]="key.rule"
                            readonly
                          >
                          </textarea>
                        </mat-form-field>
                      </td>
                      <td>
                        <div class="d-flex gap-1">
                          <button
                            mat-stroked-button
                            type="button"
                            color="primary"
                            class="icon-center icon-width"
                            (click)="openRuleEditModal(key.id)"
                            [matTooltip]="'COMMON.EDIT' | translate"
                          >
                            <mat-icon class="icon-compact">edit</mat-icon>
                          </button>

                          <button
                            mat-stroked-button
                            type="button"
                            color="warn"
                            class="icon-center icon-width"
                            (click)="deleteRule(key.id)"
                            [matTooltip]="'COMMON.DELETE' | translate"
                          >
                            <mat-icon class="icon-compact">delete</mat-icon>
                          </button>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="deleteModal1"
  tabindex="-1"
  aria-labelledby="deleteModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="deleteModalLabel">
          {{ "MODAL.DELETE.TITLE" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">{{ "MODAL.DELETE.MESSAGE" | translate }}</div>
      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-outline-secondary"
          data-bs-dismiss="modal"
        >
          {{ "COMMON.CANCEL" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-danger"
          (click)="confirmDelete()"
          data-bs-dismiss="modal"
        >
          {{ "COMMON.YES" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade"
  id="entryModal"
  tabindex="-1"
  [attr.aria-labelledby]="'MODAL.ENTRY.LABEL' | translate"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <app-uiform-entry [uiformId]="selectedItemId" [usecaseId]="usecaseId">
      </app-uiform-entry>
    </div>
  </div>
</div>

<div
  class="modal fade compact-inputs"
  id="previewModal"
  tabindex="-1"
  aria-labelledby="previewModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="previewModalLabel">
          {{ form.data["title"] || ("FORM.PREVIEW.DEFAULT_TITLE" | translate) }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <div *ngIf="form.data['id'] > 0; else noFormSelected">
          <app-uiform-preview
            [fields]="form.data.fields"
            [groupLabels]="form.data.groupLabels"
            [buttons]="form.data.buttons"
            [usecaseAttributes]="usecaseAttributes"
            [columns]="form.data.columns"
          ></app-uiform-preview>
        </div>
        <ng-template #noFormSelected>
          <div class="alert alert-info">
            {{ "FORM.MESSAGES.SELECT_FORM" | translate }}
          </div>
        </ng-template>
      </div>

      <div class="modal-footer">
        <button mat-stroked-button color="warn" data-bs-dismiss="modal">
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div
  class="modal fade compact-inputs"
  id="groupModal"
  tabindex="-1"
  aria-labelledby="groupModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="groupModalLabel">
          {{ "FORM.SECTION.ADD_TITLE" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <p *ngIf="form['error'] == false && form['message']">
          <app-ncs-alert [message]="form['message']" type="success" />
        </p>
        <p *ngIf="form['error'] == true && form['message']">
          <app-ncs-alert [message]="form['message']" type="danger" />
        </p>
        <div *ngIf="invalidTimeMsg" class="alert alert-danger" role="alert">
          {{ invalidTimeMsg }}
        </div>
        <div class="row mb-2">
          <label for="title" class="col-sm-12 col-form-label text-start">
            {{ "FORM.FIELDS.LABEL" | translate }}:
          </label>
          <div class="col-sm-12 d-flex align-items-center gap-1 mb-4">
            <mat-form-field
              appearance="outline"
              subscriptSizing="dynamic"
              class="w-100"
            >
              <input
                matInput
                type="text"
                name="groupLabel"
                id="groupLabel"
                [(ngModel)]="groupLabel"
                [placeholder]="'FORM.SECTION.LABEL_PLACEHOLDER' | translate"
              />
            </mat-form-field>
            <mat-error *ngIf="form.inputerror['groupLabel']">
              {{ form.inputerror["groupLabel"] }}
            </mat-error>
            <div class="d-flex align-items-center gap-1">
              <button
                mat-stroked-button
                class="icon-center icon-width"
                color="primary"
                type="button"
                (click)="addGroup()"
                [matTooltip]="'COMMON.ADD' | translate"
              >
                <mat-icon>add</mat-icon>
              </button>
              <button
                mat-stroked-button
                class="icon-center icon-width"
                color="warn"
                type="button"
                (click)="resetGroup()"
                [matTooltip]="'COMMON.RESET' | translate"
              >
                <i class="fa fa-eraser"></i>
              </button>
            </div>
          </div>
          <div class="col-12">
            <div class="table-container">
              <div
                class="table-responsive table-scrollable"
                *ngIf="form.data['id'] > 0"
              >
                <table
                  class="table table-bordered table-hover table-sticky-header"
                >
                  <thead>
                    <tr>
                      <th>{{ "FORM.FIELDS.LABEL" | translate }}</th>
                      <th class="text-center">
                        {{ "FORM.SECTION.TIME_RANGE" | translate }}
                      </th>
                      <th>{{ "COMMON.ACTIONS" | translate }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      *ngFor="let e of form.data['groupLabels']; let i = index"
                      (dragstart)="onDragStartSection($event, e, i)"
                      (dragover)="onDragOverSection($event)"
                      (drop)="onDropSection($event, e, i)"
                      (dragend)="onDragEndSection($event)"
                      draggable="true"
                      class="grabbable"
                    >
                      <td class="align-middle">
                        <div class="d-flex align-items-center">
                          <mat-icon class="icon-compact text-secondary"
                            >drag_indicator</mat-icon
                          >
                          <span class="ms-2">{{ e.label }}</span>
                        </div>
                      </td>
                      <td class="align-middle">
                        <div class="time-range-group">
                          <!-- Start Time -->
                          <div class="time-merged-material">
                            <mat-form-field
                              appearance="outline"
                              subscriptSizing="dynamic"
                              class="time-input-field"
                            >
                              <input
                                matInput
                                type="text"
                                [(ngModel)]="e.allowedTimeStart"
                                [placeholder]="
                                  'FORM.SECTION.TIME_PLACEHOLDER' | translate
                                "
                                (blur)="onTimeChange(e, i, 'start')"
                              />
                            </mat-form-field>

                            <mat-form-field
                              appearance="outline"
                              subscriptSizing="dynamic"
                              class="ampm-select-field"
                            >
                              <mat-select
                                [(ngModel)]="e.allowedTimeStartMeridian"
                                (selectionChange)="
                                  onMeridianChange(e, i, 'start', $event.value)
                                "
                              >
                                <mat-option value="">{{
                                  "COMMON.SELECT" | translate
                                }}</mat-option>
                                <mat-option value="AM">AM</mat-option>
                                <mat-option value="PM">PM</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <!-- End Time -->
                          <div class="time-merged-material">
                            <mat-form-field
                              appearance="outline"
                              subscriptSizing="dynamic"
                              class="time-input-field"
                            >
                              <input
                                matInput
                                type="text"
                                [(ngModel)]="e.allowedTimeEnd"
                                [placeholder]="
                                  'FORM.SECTION.TIME_PLACEHOLDER' | translate
                                "
                                (blur)="onTimeChange(e, i, 'end')"
                              />
                            </mat-form-field>

                            <mat-form-field
                              appearance="outline"
                              subscriptSizing="dynamic"
                              class="ampm-select-field"
                            >
                              <mat-select
                                [(ngModel)]="e.allowedTimeEndMeridian"
                                (selectionChange)="
                                  onMeridianChange(e, i, 'end', $event.value)
                                "
                              >
                                <mat-option value="">{{
                                  "COMMON.SELECT" | translate
                                }}</mat-option>
                                <mat-option value="AM">AM</mat-option>
                                <mat-option value="PM">PM</mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </div>
                      </td>
                      <td class="text-center align-middle">
                        <button
                          mat-stroked-button
                          type="button"
                          color="warn"
                          class="icon-center icon-width"
                          (click)="deleteGroup(e.label, i)"
                          [matTooltip]="'COMMON.DELETE' | translate"
                        >
                          <mat-icon class="icon-compact">delete</mat-icon>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer mt-3">
        <button
          mat-stroked-button
          color="warn"
          type="button"
          data-bs-dismiss="modal"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<div #messageBoxContainer></div>

<!-- Parent Filter Modal -->
<div
  class="modal fade compact-inputs dropdown-pd-none"
  id="parentModal"
  tabindex="-1"
  [attr.aria-labelledby]="'parentModalLabel'"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="parentModalLabel">
          {{ "PARENT_FILTER.MODAL_TITLE" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [attr.title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <p *ngIf="form['error'] == false && form['message']">
            <app-ncs-alert [message]="form['message']" type="success" />
          </p>
          <p *ngIf="form['error'] == true && form['message']">
            <app-ncs-alert [message]="form['message']" type="danger" />
          </p>
          <div class="row">
            <label
              for="title"
              *ngIf="parsedDataWithOperators.length > 0"
              class="col-sm-2 mb-2 col-form-label text-start"
            >
              {{ "PARENT_FILTER.CONDITION_LABEL" | translate }}:
            </label>
            <div
              class="col-sm-10 mb-2"
              *ngIf="parsedDataWithOperators.length > 0"
            >
              <mat-form-field appearance="outline" class="w-100 mb-1">
                <mat-select
                  [(ngModel)]="parentFilter['operator']"
                  name="operator"
                  [placeholder]="'PARENT_FILTER.SELECT_CONDITION' | translate"
                >
                  <mat-option [value]="undefined">
                    {{ "PARENT_FILTER.SELECT_CONDITION" | translate }}
                  </mat-option>
                  <mat-option value="||">
                    {{ "PARENT_FILTER.OR_OPERATOR" | translate }}
                  </mat-option>
                  <mat-option value="&">
                    {{ "PARENT_FILTER.AND_OPERATOR" | translate }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>

            <label for="title" class="col-sm-2 col-form-label text-start mb-2">
              {{ "PARENT_FILTER.KEY_LABEL" | translate }}:
            </label>
            <div class="col-sm-10 mb-2">
              <div class="dropdown-position-relative">
                <!-- Material Form Field with input - NO AUTOCOMPLETE, just styled input -->
                <mat-form-field appearance="outline" class="w-100 mb-1">
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="this.parentFilter['label']"
                    (input)="filterOptions()"
                    [placeholder]="'PARENT_FILTER.KEY_PLACEHOLDER' | translate"
                  />
                </mat-form-field>

                <!-- Your existing dropdown - now with Material styling via CSS -->
                <ul
                  *ngIf="filteredOptions.length > 0"
                  class="dropdown-menu show"
                  style="position: absolute; z-index: 1000"
                >
                  <li
                    *ngFor="let option of filteredOptions"
                    class="dropdown-item material-dropdown-item"
                    (click)="selectOption(option)"
                  >
                    {{ option["label"] }}
                  </li>
                </ul>
              </div>
            </div>

            <label for="title" class="col-sm-2 col-form-label text-start mb-2">
              {{ "PARENT_FILTER.VALUE_LABEL" | translate }}:
            </label>
            <div class="col-sm-10 mb-2">
              <div class="position-relative">
                <!-- <input type="text" [(ngModel)]="this.parentFilter['value']"
                                    class="form-control form-control-sm mb-1"
                                    [attr.placeholder]="'PARENT_FILTER.VALUE_PLACEHOLDER' | translate" /> -->
                <mat-form-field appearance="outline" class="w-100 mb-1">
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="parentFilter['value']"
                    name="filterValue"
                    [placeholder]="
                      'PARENT_FILTER.VALUE_PLACEHOLDER' | translate
                    "
                  />
                </mat-form-field>
              </div>
            </div>
          </div>
          <div class="segments-wrapper">
            <mat-chip-set aria-label="Data segments">
              <mat-chip-row
                *ngFor="let segment of parsedDataWithOperators; let i = index"
                [class.operator-chip]="segment === '&&' || segment === '||'"
                class="custom-chip"
              >
                <span class="chip-text">
                  {{ segment }}
                </span>

                <button
                  matChipRemove
                  [attr.aria-label]="'COMMON.DELETE' | translate"
                  (click)="removeSegment(i)"
                >
                  <mat-icon>cancel</mat-icon>
                </button>
              </mat-chip-row>
            </mat-chip-set>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          type="button"
          class="ms-2"
          [disabled]="
            !parentFilter['code'] || parentFilter['value'] === undefined
          "
          [attr.title]="'COMMON.SAVE' | translate"
          (click)="saveParentFilter()"
        >
          <mat-icon>save</mat-icon>
          {{ "COMMON.SAVE" | translate }}
        </button>

        <button
          mat-stroked-button
          color="warn"
          type="button"
          data-bs-dismiss="modal"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Show Modal -->
<div
  class="modal fade compact-inputs dropdown-pd-none"
  id="showModal"
  tabindex="-1"
  [attr.aria-labelledby]="'showModalLabel'"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="showModalLabel">
          {{ "SHOW_MODAL.MODAL_TITLE" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [attr.title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>
      <div class="modal-body">
        <div class="row">
          <p *ngIf="form['error'] == false && form['message']">
            <app-ncs-alert [message]="form['message']" type="success" />
          </p>
          <p *ngIf="form['error'] == true && form['message']">
            <app-ncs-alert [message]="form['message']" type="danger" />
          </p>
          <div class="row mb-2 justify-content-center">
            <label for="title" class="col-sm-2 col-form-label text-start">
              {{ "SHOW_MODAL.CONDITION_LABEL" | translate }}:
            </label>

            <div class="col-sm-10">
              <div class="dropdown-position-relative">
                <!-- <input type="text" [(ngModel)]="showForm['virtualValue']"
                                    class="form-control form-control-sm mb-1"
                                    [attr.placeholder]="'SHOW_MODAL.INPUT_PLACEHOLDER' | translate"
                                    (input)="showOptionswhen(); onInputChange()" (blur)="onBlur()"
                                    (keypress)="onKeyPress($event)" /> -->
                <mat-form-field appearance="outline" class="w-100 mb-1">
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="showForm['virtualValue']"
                    [placeholder]="'SHOW_MODAL.INPUT_PLACEHOLDER' | translate"
                    (input)="showOptionswhen(); onInputChange()"
                    (blur)="onBlur()"
                    (keypress)="onKeyPress($event)"
                  />
                </mat-form-field>
                <div *ngIf="showPopup">
                  <ul
                    *ngIf="showAttriOptions.length > 0"
                    class="dropdown-menu show"
                    style="position: absolute; z-index: 1000"
                  >
                    <li
                      *ngFor="let option of showAttriOptions"
                      class="dropdown-item"
                      (click)="selectShowOptionWhen(option)"
                    >
                      {{ option["label"] }}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="modal-footer">
          <button
            (click)="
              addFeild1(showForm['index'], showForm['virtualValue'], 'show')
            "
            type="button"
            [attr.title]="'COMMON.SAVE' | translate"
            class="btn btn-outline-primary btn-sm ml-2 ms-2"
          >
            <i class="fas fa-save"></i>
            {{ "COMMON.SAVE" | translate }}
          </button>
          <button
            type="button"
            class="btn btn-outline-secondary btn-sm"
            data-bs-dismiss="modal"
            [attr.title]="'COMMON.CLOSE' | translate"
          >
            <i class="fa fa-window-close"></i>
            {{ "COMMON.CLOSE" | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Add Rule Modal -->
<div
  class="modal fade"
  id="addRule"
  tabindex="-1"
  aria-labelledby="addRuleLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h1 class="modal-title fs-5" id="addRuleLabel">
          {{ "RULES.ADD_RULE" | translate }}
        </h1>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
          [title]="'COMMON.CLOSE' | translate"
        ></button>
      </div>

      <div class="modal-body">
        <div class="row">
          <p *ngIf="ruleData['error'] == false && ruleData['message']">
            <app-ncs-alert
              [message]="ruleData['message']"
              type="success"
            ></app-ncs-alert>
          </p>
          <p *ngIf="ruleData['error'] == true && ruleData['message']">
            <app-ncs-alert
              [message]="ruleData['message']"
              type="danger"
            ></app-ncs-alert>
          </p>
          <!-- Event Selection -->
          <div class="row mb-3 compact-inputs">
            <label class="col-md-3 col-form-label text-start"
              >{{ "RULES.SELECT_EVENT" | translate }}:</label
            >
            <div class="col-md-9">
              <mat-form-field
                appearance="outline"
                class="w-100"
                subscriptSizing="dynamic"
              >
                <mat-select
                  [ngModel]="ruleData.data['event']"
                  (ngModelChange)="ruleData.data['event'] = $event"
                  placeholder="{{ 'COMMON.SELECT' | translate }} {{
                    'RULES.SELECT_EVENT' | translate
                  }}"
                >
                  <mat-option value="undefined"
                    >{{ "COMMON.SELECT" | translate }}
                    {{ "RULES.SELECT_EVENT" | translate }}</mat-option
                  >
                  <mat-option value="beforeSubmit">{{
                    "RULES.EVENTS.BEFORE_SUBMIT" | translate
                  }}</mat-option>
                  <mat-option value="afterSubmit">{{
                    "RULES.EVENTS.AFTER_SUBMIT" | translate
                  }}</mat-option>
                  <mat-option value="beforeInsert">{{
                    "RULES.EVENTS.BEFORE_INSERT" | translate
                  }}</mat-option>
                  <mat-option value="afterInsert">{{
                    "RULES.EVENTS.AFTER_INSERT" | translate
                  }}</mat-option>
                  <mat-option value="beforeUpdate">{{
                    "RULES.EVENTS.BEFORE_UPDATE" | translate
                  }}</mat-option>
                  <mat-option value="afterUpdate">{{
                    "RULES.EVENTS.AFTER_UPDATE" | translate
                  }}</mat-option>
                  <mat-option value="beforeDelete">{{
                    "RULES.EVENTS.BEFORE_DELETE" | translate
                  }}</mat-option>
                  <mat-option value="afterDelete">{{
                    "RULES.EVENTS.AFTER_DELETE" | translate
                  }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>

          <!-- Rule Text Area -->
          <div class="row mb-3">
            <label class="col-md-3 col-form-label text-start"
              >{{ "RULES.RULE_LOGIC" | translate }}:</label
            >
            <div class="col-md-9 textarea-container">
              <mat-form-field appearance="outline" class="w-100">
                <textarea
                  matInput
                  [(ngModel)]="ruleData.data['rule']"
                  rows="4"
                  placeholder="{{ 'RULES.RULE_PLACEHOLDER' | translate }}"
                >
                </textarea>
              </mat-form-field>
            </div>
          </div>
        </div>
      </div>

      <!-- Footer Buttons -->
      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          class="ms-2"
          (click)="addRuleWithText()"
          [disabled]="
            !ruleData?.data['event'] ||
            ruleData?.data['event'] === 'undefined' ||
            !ruleData?.data['rule']
          "
        >
          <mat-icon>save</mat-icon>
          {{ "COMMON.SAVE" | translate }}
        </button>

        <button
          mat-stroked-button
          type="button"
          color="warn"
          data-bs-dismiss="modal"
          [matTooltip]="'COMMON.CLOSE' | translate"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Custom Button Configuration Modal -->
<div
  class="modal fade compact-inputs dropdown-pd-none"
  id="customButtonModal"
  tabindex="-1"
  aria-labelledby="customButtonModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="customButtonModalLabel">
          {{ "FORM.CUSTOM_BUTTON.TITLE" | translate }}
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          [attr.aria-label]="'COMMON.CLOSE' | translate"
        ></button>
      </div>

      <div class="modal-body">
        <p *ngIf="customButtonForm.error == false && customButtonForm.message">
          <app-ncs-alert [message]="customButtonForm.message" type="success" />
        </p>
        <p *ngIf="customButtonForm.error == true && customButtonForm.message">
          <app-ncs-alert [message]="customButtonForm.message" type="danger" />
        </p>

        <!-- Name Field -->
        <div class="row mb-3">
          <label
            for="customButtonName"
            class="col-sm-3 col-form-label text-start"
          >
            {{ "ALLREMAININGS.Name" | translate }}:
          </label>
          <div class="col-sm-9">
            <mat-form-field appearance="outline" class="w-100">
              <input
                matInput
                id="customButtonName"
                [(ngModel)]="customButtonForm.name"
                type="text"
                [placeholder]="'ALLREMAININGS.Enter_Button' | translate"
                required
              />
            </mat-form-field>
          </div>
        </div>

        <!-- Action Type Radio Buttons -->
        <div class="row mb-3">
          <label class="col-sm-3 col-form-label text-start">
            {{ "ALLREMAININGS.Action_Type" | translate }}:
          </label>
          <div class="col-sm-9">
            <mat-radio-group
              [(ngModel)]="customButtonForm.actionType"
              (change)="onActionTypeChange()"
            >
              <mat-radio-button color="primary" value="form" class="me-3">
                {{ "ALLREMAININGS.Form" | translate }}
              </mat-radio-button>
              <mat-radio-button color="primary" value="report" class="me-3">
                {{ "ALLREMAININGS.Report" | translate }}
              </mat-radio-button>
              <mat-radio-button color="primary" value="url">
                {{ "ALLREMAININGS.URL" | translate }}
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>

        <!-- Form Dropdown (shown only when actionType is 'form') -->
        <div class="row mb-3" *ngIf="customButtonForm.actionType === 'form'">
          <label
            for="customButtonForm"
            class="col-sm-3 col-form-label text-start"
          >
            {{ "ALLREMAININGS.Select_Form" | translate }}:
          </label>
          <div class="col-sm-9">
            <mat-form-field appearance="outline" class="w-100">
              <mat-select
                [(ngModel)]="customButtonForm.formId"
                id="customButtonForm"
                [placeholder]="'ALLREMAININGS.Select_Form_Place' | translate"
              >
                <mat-option [value]="undefined">
                  {{ "COMMON.SELECT" | translate }}
                </mat-option>
                <mat-option *ngFor="let form of formList" [value]="form.id">
                  {{ form.title }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- Report Dropdown (shown only when actionType is 'report') -->
        <div class="row mb-3" *ngIf="customButtonForm.actionType === 'report'">
          <label
            for="customButtonReport"
            class="col-sm-3 col-form-label text-start"
          >
            {{ "ALLREMAININGS.Select_Report" | translate }}:
          </label>
          <div class="col-sm-9">
            <mat-form-field appearance="outline" class="w-100">
              <mat-select
                [(ngModel)]="customButtonForm.reportId"
                id="customButtonReport"
                [placeholder]="'ALLREMAININGS.Select_Report_Place' | translate"
              >
                <mat-option [value]="undefined">
                  {{ "COMMON.SELECT" | translate }}
                </mat-option>
                <mat-option
                  *ngFor="let report of reportList"
                  [value]="report.id"
                >
                  {{ report.title }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>

        <!-- URL Fields (shown only when actionType is 'url') -->
        <div *ngIf="customButtonForm.actionType === 'url'">
          <!-- URL Input -->
          <div class="row mb-3">
            <label
              for="customButtonUrl"
              class="col-sm-3 col-form-label text-start"
            >
              {{ "ALLREMAININGS.URL" | translate }}:
            </label>
            <div class="col-sm-9">
              <mat-form-field appearance="outline" class="w-100">
                <input
                  matInput
                  id="customButtonUrl"
                  [(ngModel)]="customButtonForm.url"
                  type="url"
                  [placeholder]="'ALLREMAININGS.URL_Place' | translate"
                />
              </mat-form-field>
            </div>
          </div>

          <!-- URL Target (Same Tab / New Tab) -->
          <div class="row mb-3">
            <label class="col-sm-3 col-form-label text-start">
              {{ "ALLREMAININGS.OPEN_IN" | translate }}:
            </label>
            <div class="col-sm-9 d-flex align-items-center">
              <mat-checkbox
                color="primary"
                [(ngModel)]="customButtonForm.openInNewTab"
              >
                {{ "ALLREMAININGS.NEW_TAB" | translate }}
              </mat-checkbox>
            </div>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button
          mat-stroked-button
          color="primary"
          (click)="saveCustomButton()"
          [disabled]="!isCustomButtonValid()"
        >
          <mat-icon>save</mat-icon>
          {{ "COMMON.SAVE" | translate }}
        </button>
        <button
          mat-stroked-button
          color="warn"
          type="button"
          data-bs-dismiss="modal"
        >
          <mat-icon>close</mat-icon>
          {{ "COMMON.CLOSE" | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
